import "./GVTThinkingSymbol.css";

/**
 * Animated "thinking" sparkle built from three separate glyphs (thinking1/2/3)
 * that are stacked on top of each other via stylesheet rules. Because each
 * layer is its own element, their opacities can be animated independently
 * so the stars in the layers twinkle.
 *
 * Decorative only, so it is hidden from assistive tech and not selectable.
 */
export const GVTThinkingSymbol = (props: { class?: string }) => {
	return (
		<span class={`gvt-thinking-symbol ${props.class ?? ""}`} aria-hidden="true">
			<span class="gvt-thinking-symbol__layer gvt-thinking-symbol__layer--1">thinkone</span>
			<span class="gvt-thinking-symbol__layer gvt-thinking-symbol__layer--2">thinktwo</span>
			<span class="gvt-thinking-symbol__layer gvt-thinking-symbol__layer--3">thinkthree</span>
		</span>
	);
};
